export default __webpack_public_path__ + "static/teaser-2f3f8fc0a8f329061a835cff2b6af9ca.svg";